<template>
  <div>
    <section class="banner-perfil parallax-window" data-parallax="scroll" :data-image-src="bannerPerfil">
      <div class="container text-center">
        <h1>{{ aluno.nome }}</h1>
      </div>
    </section>
    <section class="perfil container">
      <div class="row">
        <div class="col-12 col-md-4">

          <div class="box-categorias mb-4">
            <div class="foto-aluno text-center">
              <b-form-file id="foto-perfil" @input="salvar()"
                v-model="imagemSelecionada"
                placeholder="Inserir imagem"
                browse-text="Selecionar"
                accept="image/jpeg, image/png"
                ref="formFile"
                style="display:none;"
              ></b-form-file>
              <a href="#">
                <p @click="searchFile()"><i class="fas fa-pencil-alt" @click="searchFile()"></i> alterar foto</p>
                <img :src="aluno.avatar" @click="searchFile()" alt="Foto do aluno">
              </a>
            </div>

            <menu-lateral-perfil :aluno="aluno"/>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <div class="box-perfil">
            <div class="tab-content" id="v-pills-tabContent">

              <transition name="slide-fade" mode="out-in">
                <router-view :aluno="aluno"></router-view>
              </transition>

            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import $ from 'jquery'
import Swal from 'sweetalert2'
import 'jquery-parallax.js'
import PerfilAPI from '@/api/perfil-api'
import MenuLateralPerfil from '@/modules/Perfil/components/MenuLateralPerfil'
import ImageUtils from '@/core/utils/image-utils'
import LoginUtils from '@/core/utils/login-utils'
import ResponseUtils from '@/core/utils/response-utils'
import UsuarioAPI from '@/api/usuario-api'

export default {
  name: 'PerfilApp',
  components: { MenuLateralPerfil },
  data () {
    return {
      aluno: {
        name: '',
        avatar: '',
        tutorias: []
      },
      imagemSelecionada: '',
      imagem: '',
      imagemPadrao: ''
    }
  },
  created () {
    if (this.$configEmpresa.bannerParallax && this.$configEmpresa.bannerParallax.perfil) {
      this.bannerPerfil = `${process.env.VUE_APP_BASE_FILES_URL}empresas/imgs/${process.env.VUE_APP_EMPRESA_REF}/${this.$configEmpresa.bannerParallax.perfil}`
    } else {
      this.bannerPerfil = require('@/assets/img/bannerperfil.jpg')
    }
  },
  updated () {
    $('.parallax-window').parallax({ imageSrc: this.bannerPerfil })
  },
  beforeDestroy () {
    $('.parallax-mirror').remove()
  },
  async mounted () {
    let aluno = await PerfilAPI.obterPerfil()
    this.aluno = {
      nome: aluno.perfil_aluno.name,
      email: aluno.perfil_plano.email,
      cpf: aluno.perfil_aluno.cpf,

      dataNascimento: aluno.perfil_aluno.data_nascimento,
      telefone: aluno.perfil_aluno.telefone,
      infoExtra: aluno.perfil_aluno.informacao_extra,

      senha: '******',
      avatar: aluno.perfil.avatar ? ImageUtils.obterUrlCompletaImagem(aluno.perfil.avatar) : ImageUtils.obterUrlCompletaImagem(LoginUtils.getUsuario().avatar),

      idFaculdade: aluno.perfil_faculdade.id,
      siglaFaculdade: aluno.perfil_faculdade.siglaFacul,
      nomeFaculdade: aluno.perfil_faculdade.nomeFacul,
      anoInicio: aluno.perfil_faculdade.ano_inicio,
      semestreInicio: aluno.perfil_faculdade.semestre_inicio,
      paisFaculdade: aluno.perfil_faculdade.paisFacul,
      estadoFaculdade: aluno.perfil_faculdade.estadoFacul,
      periodoAtual: aluno.perfil_faculdade.periodo_atual
    }
    $(window).trigger('resize.px.parallax')
  },
  methods: {
    searchFile: function () {
      let fileInput = document.getElementById('foto-perfil')
      fileInput.click()
    },
    salvar: function () {
      const loader = this.$loading.show()

      PerfilAPI.editarFoto(this.imagemSelecionada).then(async data => {
        loader.hide()

        if (data.type === 'error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Ok',
            title: 'Falha ao tentar editar foto!'
          })
        } else {
          const usuario = await UsuarioAPI.obterUsuario().then(data => {
            let usuario = data.user
            usuario.planos = data.plano
            usuario.planoPrincipal = data.planoPrincipal
            usuario.perfilUsuario = data.user.perfil

            return usuario
          })

          if (usuario) {
            const perfil = await PerfilAPI.obterPerfil()
            if (perfil) {
              usuario.perfil = perfil
            }

            LoginUtils.setUsuario(usuario)
          }

          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Ok',
            title: 'Foto editada com sucesso!'
          }).then((result) => {
            if (result.value) {
              location.reload()
            } else {
            }
          })
        }
      }).catch(error => ResponseUtils.handleError(error, loader))
    }
  }
}
</script>

<style scoped>

</style>
